<template>
	<footer class="footer">
		<div class="container">


			<div class="copyright">
				<b>&copy; {{ new Date().getFullYear() }}</b> <b><span class="text-primary"> M789 BET</span></b>
			</div>
			<div class="copyright text-center">
				បង្កើតដោយ <span class="text-primary"><b>CAM99 Gaming</b></span>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Layout/ContentFooter.vue